import logoColor from "@/assets/onekite-logo.png";
import logoWhite from "@/assets/onekite-logo-white.png";
import iconColor from "@/assets/onekite-icon.png";
import iconWhite from "@/assets/onekite-icon-white.png";

// OneKite logo. `mark` renders the icon only; otherwise the full lockup (icon + wordmark).
// Size via height class. `variant="white"` for dark backgrounds.
export default function Logo({ variant = "color", mark = false, className = "h-8" }) {
  const src = mark
    ? (variant === "white" ? iconWhite : iconColor)
    : (variant === "white" ? logoWhite : logoColor);
  return <img src={src} alt="OneKite" className={`w-auto ${className}`} draggable="false" />;
}
